import React from 'react';
import "../styles/Thankyou.scss"

function ThankYou() {
  return (
    <div className='thank-you'>
      <h1>Thank you!</h1>
      <p>Your message has been sent successfully.</p>
    </div>
  );
}

export default ThankYou;